module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BS-3e7ae46260f2a52955c9082f50127ad9.png";